import React from 'react';

interface ILoadingOverlayProps {
    active: boolean;
    children?: JSX.Element;
}

const LoadingOverlay = ({ active, children }: ILoadingOverlayProps) => {
    const $ = window.jQuery;

    if ($ !== undefined) {
        if (active || window.site === undefined || window.site.loading) {
            // tslint:disable-next-line: no-unused-expression
            $('#mobileSpin').fadeTo(null, 0.4);
        } else {
            $('#mobileSpin').fadeOut();
        }
    }

    return <>{children}</>;
};

export default LoadingOverlay;
